import HeroContent from './common/HeroContent'

export default function HeroBanner() {
  return (
    <section className="relative overflow-hidden py-20 md:py-32 flex items-center min-h-[80vh]">
      {/* Content Overlay - Background sẽ dùng từ HomePage fixed background */}
      <div className="container mx-auto relative z-10 px-4 py-12">
        <HeroContent />
      </div>
    </section>
  )
}

